<!-- 並び替えアイテム -->
<template>
  <li
    class="crly-a-contents-sort-item list-group-item crly-icon"
    :class="item.class"
    :itemKey="item.key"
  >
    <label> {{ item.name }} </label>
    <span class="handle" @touchmove.prevent=""></span>
  </li>
</template>

<script>
export default {
  name: "CrlyAtomsContentsSortItem",
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/atoms/contents/sortItem.scss";
</style>
